import "./setupGlobals";

async function __main__(): Promise<void> {
  await import("./main.tsx");
}

__main__().catch((error) => {
  console.error("Error initializing the app:", error);
  alert(`Cannot initialize the app: ${error}`);
});
